module.exports = __webpack_public_path__ + "img/2-01.c6eada50.png";